import { Pipe, PipeTransform } from '@angular/core';
import { CognitoService } from '../services/cognito.service';
import { CacheService } from '../services/cache.service';

@Pipe({
	name: 'displayName',
	standalone: true,
	pure: true,
})
export class DisplayNamePipe implements PipeTransform {
	constructor(
		private cognitoService: CognitoService,
		private cacheService: CacheService
	) {}

	async transform(
		value: string | null | undefined,
		type: 'user' | 'cognito' = 'user',
		userPoolId?: string
	): Promise<string> {
		if (!value) {
			return '';
		}

		const cacheKey = `displayName-${type}-${value}-${userPoolId || 'auto'}`;

		const str = await this.cacheService.get<string>(
			cacheKey,
			() =>
				this.cognitoService.getDisplayName({
					...(type === 'user' ? { user_uuid: value } : { cognito_uuid: value }),
					userPoolId,
				}),
			value
		);

		return str;
	}
}
